<template>
  <div id="app" :class="{ 'app-shell': showRecordFooter }">
    <main :class="{ 'app-main': showRecordFooter }">
      <router-view/>
    </main>
    <CashierRecordFooter v-if="showRecordFooter" />
  </div>
</template>

<script>
import CashierRecordFooter from './components/CashierRecordFooter.vue'

const PERSON_WEB_ROUTE_NAMES = ['PersonWebHome', 'PersonWebArticles', 'PersonWebArticle', 'PersonWebSourceDownload']

export default {
  name: 'App',
  components: {
    CashierRecordFooter
  },
  computed: {
    showRecordFooter() {
      return !PERSON_WEB_ROUTE_NAMES.includes(this.$route.name)
    }
  }
}
</script>

<style>
@import './styles/cashier-base.css';

#app.app-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-main {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
}
</style>
